var React = require('react');

function Facebook32 (props) {
    return React.createElement("svg",props,[React.createElement("metadata",{"key":0}),React.createElement("defs",{"key":1},React.createElement("style",null,"\n      .cls-1 {\n        fill: #7e8082;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"Facebook_32","className":"cls-1","d":"M1538,57a16,16,0,1,1-16,16A16.007,16.007,0,0,1,1538,57Zm2,12v1h4l-1,3h-3v9h-4V73h-2V70h2V67a2.923,2.923,0,0,1,3-3h4v4h-2A1.157,1.157,0,0,0,1540,69Z","transform":"translate(-1522 -57)","key":2})]);
}

Facebook32.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Facebook32;

Facebook32.default = Facebook32;
